<aside class="sticky top-[100px] z-20" *transloco="let t; prefix: 'property-details.aside'">
  <div
    class="flex flex-col bg-white xl:relative fixed gap-4 bottom-0 right-0 left-0 xl:rounded-b-medium rounded-t-medium p-6 shadow-[0px_3px_24px_0px_#0000000A] xl:max-w-[283px]">
    <h3 class="text-black font-semibold rfs:text-2xl xl:mb-8 flex flex-row items-center justify-between"> {{
      t("aside-title") }} <button (click)="toggleAside()" type="button" class="text-primary-600 xl:hidden">
        <i [ngClass]="{
            'icon-chevron-down': !isOpen,
            'icon-chevron-up': isOpen,
          }"></i>
      </button>
    </h3>
    <div class="xl:hidden">
      <button *ngIf="!this.isAuctioned" (click)="onMakeOfferClick()"
        class="btn-primary flex flex-row items-center justify-between w-full"> {{
        t("make-an-offer") }} <i class="icon-make-an-offer"></i>
      </button>
      <!-- Hidden bidding support button so that we hide the bidding support for now #45953-->
      <button *ngIf="this.isAuctioned" [localizedRouterLink]="['/services/biddingSupport']" [queryParams]="{ property: this.property?.code}"
        class="btn-primary flex flex-row items-center justify-between w-full"> {{
        t("how-to-participate") }} <i class="icon-make-an-offer"></i>
      </button>
    </div>

    <div class="flex flex-col xl:flex hidden gap-4">
      <div *ngIf="this.isAuctioned" class="bg-gray-50 border border-gray-300 rounded-xl p-4 w-full max-w-xs">
        <div class="flex flex-1 justify-between">
          <h3 class="text-gray-950 font-semibold text-left items-center">
            {{t("remaining")}}: </h3>
          <i class="icon-info-circle self-center relative" [tooltip]="t('remaining-tooltip')"></i>
        </div>
        <div class="flex justify-between items-center gap-2 mt-2 text-green-700 font-bold text-lg">
          <div class="text-center">
            <p>{{property?.timeSpanToNextRound?.days}}</p>
            <p class="text-black text-sm font-normal">{{t("days")}}</p>
          </div>
          <div class="border-l border-gray-300 h-[24px]"></div>
          <div class="text-center">
            <p>{{property?.timeSpanToNextRound?.hours}}</p>
            <p class="text-black text-sm font-normal">{{t("hours")}}</p>
          </div>
          <div class="border-l border-gray-300 h-[24px]"></div>
          <div class="text-center">
            <p>{{property?.timeSpanToNextRound?.minutes}}</p>
            <p class="text-black text-sm font-normal">{{t("minutes")}}</p>
          </div>

        </div>
      </div>
      <app-experts-callback [property]="property"
        [modalComponent]="'RequestCallbackModalComponent'"></app-experts-callback>
    </div>
    <div class="flex flex-col xl:flex hidden">
      <button *ngIf="!this.isAuctioned" (click)="onAskTourClick()"
        class="btn-secondary text-nowrap flex flex-row items-center justify-between w-full mb-4"> {{ t("ask-for-toor")
        }} <i class="icon-key"></i>
      </button>
      <button *ngIf="!this.isAuctioned" (click)="onMakeOfferClick()"
        class="btn-primary flex flex-row items-center justify-between w-full"> {{
        t("make-an-offer") }} <i class="icon-make-an-offer"></i>
      </button>
      <!-- Hidden bidding support button so that we hide the bidding support for now #45953-->
      <!-- <button *ngIf="this.isAuctioned" [localizedRouterLink]="['/services/biddingSupport']"
        [queryParams]="{ property: this.property?.code}"
        class="btn-primary flex flex-row items-center justify-between w-full"> {{
        t("how-to-participate") }} <i class="icon-make-an-offer"></i>
      </button> -->
    </div>
    <div [ngClass]="{ 'h-0': !isOpen, 'h-[auto]': isOpen }" class="xl:hidden block overflow-hidden">
      <div *ngIf="this.isAuctioned" class="bg-gray-50 border border-gray-300 rounded-xl p-4 my-4 w-full">
        <div class="flex flex-1 justify-between">
          <h3 class="text-gray-950 font-semibold text-left items-center">
            {{t("remaining")}}: </h3>
          <i class="icon-info-circle self-center relative" [tooltip]="t('remaining-tooltip')"></i>
        </div>
        <div class="flex justify-evenly items-center gap-2 mt-2 text-green-700 font-bold text-lg">
          <div class="text-center">
            <p>{{property?.timeSpanToNextRound?.days}}</p>
            <p class="text-black text-sm font-normal">{{t("days")}}</p>
          </div>
          <div class="border-l border-gray-300 h-[24px]"></div>
          <div class="text-center">
            <p>{{property?.timeSpanToNextRound?.hours}}</p>
            <p class="text-black text-sm font-normal">{{t("hours")}}</p>
          </div>
          <div class="border-l border-gray-300 h-[24px]"></div>
          <div class="text-center">
            <p>{{property?.timeSpanToNextRound?.minutes}}</p>
            <p class="text-black text-sm font-normal">{{t("minutes")}}</p>
          </div>

        </div>
      </div>
      <button *ngIf="!this.isAuctioned" (click)="onAskTourClick()"
        class="btn-secondary text-nowrap flex flex-row items-center justify-between w-full mb-4"> {{ t("ask-for-toor")
        }} <i class="icon-key"></i>
      </button>
      <app-experts-callback [property]="property"
        [modalComponent]="'RequestCallbackModalComponent'"></app-experts-callback>
    </div>
  </div>
</aside>